import type { SpeedStrategy, SpeedView } from "@shared/site-audit-report-view";
import { ReportSection } from "./section";

export function SpeedCards({ speed }: { speed: SpeedView }) {
  return (
    <ReportSection
      id="speed"
      title="Speed"
      hint="Lab LCP 2.5s, lab TBT 200ms, CLS 0.1. Field INP 200ms when field data exists."
    >
      {speed.legacyNote ? <p className="text-sm text-foreground/75">{speed.legacyNote}</p> : null}
      {speed.failures.length > 0 ? (
        <ul className="space-y-1">
          {speed.failures.map((failure) => (
            <li key={`${failure.url}-${failure.strategy}`} className="text-sm text-destructive">
              {failure.strategy} failed for {failure.url}. {failure.message}
            </li>
          ))}
        </ul>
      ) : null}
      {speed.pages.length === 0 ? (
        <p className="text-sm text-foreground/75">{speed.emptyLabel ?? "Not collected"}</p>
      ) : (
        <div className="space-y-4">
          {speed.pages.map((page) => (
            <article key={page.url || "page"} className="space-y-3 rounded-[0.75rem] border border-border p-4">
              <h3 className="truncate font-mono text-sm">{page.url || "URL not stored"}</h3>
              <div className="grid gap-4 sm:grid-cols-2">
                <StrategyColumn label="Mobile" strategy={page.mobile} />
                <StrategyColumn label="Desktop" strategy={page.desktop} />
              </div>
            </article>
          ))}
        </div>
      )}
    </ReportSection>
  );
}

function StrategyColumn({ label, strategy }: { label: string; strategy: SpeedStrategy | null }) {
  if (!strategy) {
    return (
      <div>
        <h4 className="text-sm font-semibold">{label}</h4>
        <p className="mt-2 text-sm text-foreground/75">Not collected</p>
      </div>
    );
  }
  return (
    <div>
      <h4 className="text-sm font-semibold">{label}</h4>
      <p className="mt-1 font-mono text-lg font-semibold tabular-nums">{strategy.scoreLabel}</p>
      <p className="text-xs text-foreground/75">{strategy.fieldNote}</p>
      <ul className="mt-2 space-y-1">
        {strategy.metrics.map((metric) => (
          <li key={metric.id} className="flex items-baseline justify-between gap-3 text-sm">
            <span>{metric.label}</span>
            <span className="text-right tabular-nums">
              {metric.state === "empty" ? metric.emptyLabel : metric.value}
              {metric.bandLabel ? (
                <span className={metric.band === "poor" ? " text-destructive" : metric.band === "good" ? " text-chart-2" : " text-chart-3"}>
                  {" "}
                  {metric.bandLabel}
                </span>
              ) : null}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
